export const LIVE_SERVICE_STATUS = {
    live: "No Shutdown",
    shutdown: "Shutdown",
  }
  export const checkAllFalse = (statusObj) => {return Object.values(statusObj).every(value => value === false);}